<template>
    <div
        id="accessibilityTable"
        class="column is-10 is-offset-1 box"
    >
        <table class="table is-fullwidth center-table">
            <thead>
                <th colspan="3">Non-raw material selection</th>
            </thead>
            <tbody>
                <tr>
                    <td class="">Drinking water pH</td>
                    <td class="">
                        <slider
                            id="waterPHSlider"
                            type="info"
                            size="large"
                            :value="Number(waterPH)"
                            :min="4"
                            :max="8"
                            :step="1"
                            is-fullwidth
                            @change="updateWaterPH"
                        ></slider>
                    </td>
                    <td><input
                            class="input"
                            type="number"
                            v-model="waterPH"
                            min="4"
                            max="8"
                            number
                        ></td>
                </tr>
                <tr>
                    <td>Drinking water temperature (C)</td>
                    <td>
                        <slider
                            id="waterTemperatureSlider"
                            type="info"
                            size="large"
                            :value="Number(waterTemp)"
                            :min="3"
                            :max="38"
                            :step="1"
                            is-fullwidth
                            @change="updateWaterTemp"
                        ></slider>
                    </td>
                    <td><input
                            class="input"
                            type="number"
                            v-model="waterTemp"
                            min="3"
                            max="38"
                            number
                        ></td>
                </tr>
                <tr>
                    <td>Dietary Cl (%)</td>
                    <td>
                        <slider
                            id="waterTemperatureSlider"
                            type="info"
                            size="large"
                            :value="Number(dietaryCl)"
                            :min="0.18"
                            :max="0.40"
                            :step="0.01"
                            is-fullwidth
                            @change="updateDietaryCl"
                        ></slider>
                    </td>
                    <td><input
                            class="input"
                            type="number"
                            v-model="dietaryCl"
                            min="0.18"
                            max="0.40"
                            step="0.01"
                            number
                        ></td>
                </tr>
                <tr>
                    <td>Protease</td>
                    <td>
                        <toggle-button
                            class="tglFontSize"
                            :width="100"
                            :height="35"
                            v-model="protease"
                            :color="{checked: '#22a7f0', unchecked: '#dfe0df'}"
                            :sync="true"
                        />
                    </td>
                    <td v-text="getYesNo(protease)"></td>
                </tr>
                <tr>
                    <td>Carbohydrase</td>
                    <td>
                        <toggle-button
                            class="tglFontSize"
                            :width="100"
                            :height="35"
                            v-model="carbohydrase"
                            :color="{checked: '#22a7f0', unchecked: '#dfe0df'}"
                            :sync="true"
                        />
                    </td>
                    <td v-text="getYesNo(carbohydrase)"></td>
                </tr>
                <tr>
                    <td>Acidifier in water or feed</td>
                    <td>
                        <toggle-button
                            class="tglFontSize"
                            :width="100"
                            :height="35"
                            v-model="acidifier"
                            :color="{checked: '#22a7f0', unchecked: '#dfe0df'}"
                            :sync="true"
                        />
                    </td>
                    <td v-text="getYesNo(acidifier)"></td>
                </tr>
                <tr>
                    <td>Pharmaceutical Zn or Cu</td>
                    <td>
                        <toggle-button
                            class="tglFontSize"
                            :width="100"
                            :height="35"
                            v-model="znOrCu"
                            :color="{checked: '#22a7f0', unchecked: '#dfe0df'}"
                            :sync="true"
                        />
                    </td>
                    <td v-text="getYesNo(znOrCu)"></td>
                </tr>
                <tr>
                    <td>Diet Ca (%)</td>
                    <td>
                        <slider
                            id="dietCaSlider"
                            type="info"
                            size="large"
                            :value="Number(dietCa)"
                            :min="0.5"
                            :max="1.2"
                            :step="0.05"
                            is-fullwidth
                            @change="updateDietCa"
                        ></slider>
                    </td>
                    <td><input
                            class="input"
                            type="number"
                            v-model="dietCa"
                            min="0.5"
                            max="1.2"
                            step="0.05"
                            number
                        ></td>
                </tr>
                <tr>
                    <th colspan="2">Corrected Accessibility Factor</th>
                    <th v-text="this.roundedCorrectedAccessibility * 100 + '%'"></th>
                </tr>
                <tr>
                    <th colspan="2">Reactive/Soluble Phytate P Estimate</th>
                    <th v-text="this.roundedCorrectedPhytateP + '%'"></th>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import Slider from "./Slider";
import ToggleButton from "vue-js-toggle-button/src/Button";

export default {
    props: ["totalPhytateP", "accessiblePhytateP", "defaultValue"],
    components: {
        Slider,
        ToggleButton
    },
    data() {
        return {
            waterPH: 7,
            waterTemp: 10,
            dietaryCl: 0.27,
            protease: false,
            carbohydrase: false,
            acidifier: false,
            znOrCu: false,
            dietCa: 0.8,
            dietCP: 20
        };
    },
    computed: {
        waterPhFactor() {
            return _.round((-(this.waterPH - 7) / this.waterPH) * 3 * 100, 2);
        },
        waterTempFactor() {
            return _.round(
                ((this.waterTemp - 10) / this.waterTemp) * 0.3 * 100,
                2
            );
        },
        dietaryClFactor() {
            return _.round(((this.dietaryCl - 0.27) / this.dietaryCl) * 100, 2);
        },
        proteaseFactor() {
            return this.protease ? 0.5 * 100 : 0;
        },
        carbohydraseFactor() {
            return this.carbohydrase ? 0.5 * 100 : 0;
        },
        acidifierFactor() {
            return this.acidifier ? 0.8 * 100 : 0;
        },
        znOrCuFactor() {
            return this.znOrCu ? -0.8 * 100 : 0;
        },
        dietCaFactor() {
            return _.round((-(this.dietCa - 0.8) / this.dietCa) * 6 * 100, 2);
        },
        phytateCP() {
            return _.round(
                ((this.accessiblePhytateP / 0.282) * 1000) / (this.dietCP * 10),
                4
            );
        },
        phytateCPFactor() {
            return _.round(
                (-(this.phytateCP - 0.04) / this.phytateCP) * 3 * 100,
                2
            );
        },
        caPhytateP() {
            return _.round(this.dietCa / (this.accessiblePhytateP * 100), 4);
        },
        caPhytatePFactor() {
            return _.round(
                (-(this.caPhytateP - 3) / this.caPhytateP) * 10 * 100,
                2
            );
        },
        average() {
            return _.round(
                (this.waterPhFactor +
                    this.waterTempFactor +
                    this.dietaryClFactor +
                    this.proteaseFactor +
                    this.carbohydraseFactor +
                    this.acidifierFactor +
                    this.znOrCuFactor +
                    this.dietCaFactor) /
                    8,
                2
            );
        },
        correctedPhytateP() {
            return (
                (this.average / 100) *
                    (this.totalPhytateP - this.accessiblePhytateP) +
                this.accessiblePhytateP
            );
        },
        roundedCorrectedPhytateP() {
            return _.round(this.correctedPhytateP, 3);
        },
        correctedAccessibility() {
            let calculatedAccessibility = (this.defaultValue * 100 + 0.2 * this.average) / 100;
            return this.phytateCP >= 4.00 && this.phytateCP <= 6.00 ? calculatedAccessibility - 0.02 : calculatedAccessibility;
        },
        roundedCorrectedAccessibility() {
            return _.round(this.correctedAccessibility, 2);
        }
    },

    watch: {
        correctedPhytateP: function() {
            this.$emit("correctedPhytatePUpdated", {
                correctedPhytateP: this.correctedPhytateP
            });
        },
        correctedAccessibility: function() {
            this.$emit("accessibilityUpdated", {
                correctedAccessibility: this.correctedAccessibility
            });
        }
    },

    methods: {
        updateWaterPH(val) {
            this.waterPH = Number(val);
        },
        updateWaterTemp(val) {
            this.waterTemp = Number(val);
        },
        updateDietaryCl(val) {
            this.dietaryCl = Number(val);
        },
        updateDietCa(val) {
            this.dietCa = Number(val);
        },
        updateDietCP(val) {
            this.dietCP = Number(val);
        },
        getYesNo(booleanValue) {
            return booleanValue ? "Yes" : "No";
        }
    }
};
</script>
<style type="text/css">
#accessibilityTable th {
    text-align: center;
}
#accessibilityTable .tglFontSize {
    font-size: 16px;
}
</style>
